import React, { useEffect, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import * as XLSX from "xlsx";
import {
  Button,
  Card,
  Form,
  Col,
  Row,
  Modal,
} from "react-bootstrap";
import { BsSearch, BsFileEarmarkExcel } from "react-icons/bs";
import { MsgInformativo } from "../../../Utils/Toast/msgInformativo";
import CatVacaciones from "../../../Services/Catalogos/CatVacaciones";
import DTOVacacionesInactivas from "./DTO/DTOVacacionesInactivas";

export default function RhVacacionesInactivas() {
  const [data, setData] = useState<DTOVacacionesInactivas[]>([]);
  const [filteredData, setFilteredData] = useState<DTOVacacionesInactivas[]>([]);

const [inicio, setInicio] = useState("");
const [fin, setFin] = useState("");

  const [filtro, setFiltro] = useState("");

  const [show, setShowMsg] = useState(false);
  const [msg, setMsg] = useState("");
  const [header, setHeader] = useState("");
  const msgColor = "primary";

  const [detalleTexto, setDetalleTexto] = useState("");
  const [showDetalle, setShowDetalle] = useState(false);

  function currentDate(): string {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
  }

  const formatearFecha = (fecha: string) => {
    if (!fecha) return "";
    const date = new Date(fecha);
    const dia = date.getDate().toString().padStart(2, "0");
    const mes = (date.getMonth() + 1).toString().padStart(2, "0");
    const anio = date.getFullYear();
    return `${dia}/${mes}/${anio}`;
  };

          
        
const generarReporte = () => {
  CatVacaciones.getVacacionesInactivas(inicio, fin)
    .then((response) => {

      const datos = response.data;

      setData(datos);
      setFilteredData(datos);

      
      if (datos.length > 0) {
        const fechas = datos
          .map(d => new Date(d.fechaSolicitud).getTime())
          .filter(f => !isNaN(f));

        if (fechas.length > 0) {
          const fechaMin = new Date(Math.min(...fechas));
          const fechaMax = new Date(Math.max(...fechas));

          const formato = (f: Date) =>
            `${f.getFullYear()}-${String(f.getMonth() + 1).padStart(2, "0")}-${String(f.getDate()).padStart(2, "0")}`;

          setInicio(formato(fechaMin));
          setFin(formato(fechaMax));
        }
      }

      setHeader("Informativo");
      setMsg("Se encontró información del periodo seleccionado.");
      setShowMsg(true);

    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || "Error al cargar los datos.";
      setHeader("Error");
      setMsg(errorMessage);
      setShowMsg(true);
    });
};



  const filtraReporte = (e: any) => {
    const searchText = e.target.value.toLowerCase();
    setFiltro(searchText);

    const filtered = data.filter((item) =>
      item.numEmpleado?.toString().toLowerCase().includes(searchText) ||
      item.nombre?.toLowerCase().includes(searchText) ||
      item.tipoSolicitud?.toLowerCase().includes(searchText)
    );

    setFilteredData(filtered);
  };

  // Exportar Excel
  const downloadExcel = () => {
    const filteredColumns = filteredData.map(({
      numEmpleado,
      nombre,
      anosServicio,
      diasTomados,
      diasRestantes,
      tipoSolicitud,
      diasSalteados,
      fechaRegistro,
      restantesPorPagar,
      estado,
      comentario,
      fechaSolicitud,
      anio
    }) => ({
      numEmpleado,
      nombre,
      anosServicio,
      diasTomados,
      diasRestantes,
      tipoSolicitud,
      diasSalteados,
      fechaRegistro: fechaRegistro ? new Date(fechaRegistro).toLocaleDateString() : "",
      restantesPorPagar,
      estado,
      comentario,
      fechaSolicitud: fechaSolicitud ? new Date(fechaSolicitud).toLocaleDateString() : "",
      anio
    }));

    exportExcel(filteredColumns, "VacacionesInactivas");
  };

  const exportExcel = (jsonData: any[], fileName: string) => {
    const Heading = [[
      "No.Empleado",
      "Nombre",
      "Años Servicio",
      "Días Tomados",
      "Días Restantes",
      "Tipo Solicitud",
      "Días Salteados",
      "Fecha Registro",
      "Restantes Pagar",
      "Estado",
      "Comentario",
      "Fecha Solicitud",
      "Año"
    ]];

    const wb = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, Heading);
    XLSX.utils.sheet_add_json(ws, jsonData, { origin: "A2", skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, "Vacaciones Inactivas");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  // Columnas tabla
  const columns: TableColumn<DTOVacacionesInactivas>[] = [
    { name: "Empleado", selector: row => row.nombre, sortable: true },
    { name: "No.Empleado", selector: row => row.numEmpleado, sortable: true },
    { name: "Años Servicio", selector: row => row.anosServicio, sortable: true },
    { name: "Días Tomados", selector: row => row.diasTomados, sortable: true },
    { name: "Días Restantes", selector: row => row.diasRestantes, sortable: true },
    { name: "Tipo Solicitud", selector: row => row.tipoSolicitud, sortable: true },
    { name: "Días Salteados", selector: row => row.diasSalteados, sortable: true },
    { name: "RestantesPorPagar",  selector: row =>  row.restantesPorPagar, sortable: true }, 
    { name: "Estado", selector: row => row.estado, sortable: true },
    { name: "Comentario", selector: row => row.comentario, sortable: true },
    { name: "Fecha Solicitud", selector: row => row.fechaSolicitud ? formatearFecha(row.fechaSolicitud) : "", sortable: true },
    { name: "Año", selector: row => row.anio, sortable: true },
  ];

  // Colores
  const conditionalRowStyles = [
    {
      when: (row: DTOVacacionesInactivas) => row.estado === 'Aceptado',
      style: { backgroundColor: '#d4edda', color: '#155724', cursor: 'pointer' }
    },
    {
      when: (row: DTOVacacionesInactivas) => row.estado === 'Pendiente',
      style: { backgroundColor: '#f8d7da', color: '#721c24', cursor: 'pointer' }
    }
  ];

  return (
    <div className="mt-2">
      <Card.Body>
        <Form>
          <Row className="align-items-center">
            <Col xs={2}>
              <Form.Label>Desde</Form.Label>
              <Form.Control type="date" value={inicio} onChange={(e) => setInicio(e.target.value)} size="sm" />
            </Col>

            <Col xs={2}>
              <Form.Label>Hasta</Form.Label>
              <Form.Control type="date" value={fin} onChange={(e) => setFin(e.target.value)} size="sm" />
            </Col>

            <Col xs={2}>
              <Form.Label>Buscar</Form.Label>
              <Form.Control type="text" size="sm" placeholder="Buscar..." onChange={filtraReporte} />
            </Col>

            <Col xs={2}>
              <Button variant="primary" onClick={generarReporte}>
                <BsSearch /> Buscar
              </Button>
            </Col>

            <Col xs={2}>
              <Button variant="success" onClick={downloadExcel}>
                <BsFileEarmarkExcel /> Excel
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>

      <Card className="mt-3">
        <Card.Body>
          <DataTable
            noHeader
            defaultSortAsc
            striped
            dense
            pagination
            highlightOnHover
            columns={columns}
            data={filteredData}
            conditionalRowStyles={conditionalRowStyles}
          />
        </Card.Body>
      </Card>

      <MsgInformativo
        show={show}
        msg={msg}
        header={header}
        msgColor={msgColor}
        closeToast={() => setShowMsg(false)}
      />
    </div>
  );
}
